import React from "react";
import Carousel from "react-multi-carousel";
import { Link } from "react-router-dom";
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1025 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1025, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const Secbann = () => {
  return (
    <div>
      <div class="banner-section">
        <Carousel
          responsive={responsive}
          arrows={false}
          showDots={true}
          autoPlay={false}
          infinite={false}
          // autoPlaySpeed={2000}
          class="main-slider-carousel .owl-carousel .owl-item"
        >
          <div
            class="slide"
            // style={{
            //   // backgroundImage: "url(../../assets/Images/main-slider/iot.png)",
            //   background:"url(../../../../public/assets/Videos/Iot-Video.mp4)",
            // }}
          >
            <video autoPlay loop muted playsInline className="background-video">
              <source
                src="/assets/Videos/0_Technology_Circuit_Board_3840x2160.mp4"
                type="video/mp4"
              />
            </video>

            <div class="container">
              {/* <!-- Content Column --> */}
              <div class="content-column">
                <div class="inner-column">
                  <div
                    class="patern-layer-three"
                    style={{
                      backgroundImage:
                        "url(../../assets/Images/main-slider/pattern-3.png)",
                    }}
                  ></div>
                  <div class="title">
                    <h1>Engineering the Complete IoT Ecosystem</h1>
                  </div>

                  <div class="text">
                    From embedded design to scalable cloud architecture —
                    VINCOSYS delivers precise, reliable, and production-ready
                    IoT systems.{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="slide"
            // style={{
            //   // backgroundImage: "url(../../assets/Images/main-slider/iot.png)",
            //   background:"url(../../../../public/assets/Videos/Iot-Video.mp4)",
            // }}
          >
            <video autoPlay loop muted playsInline className="background-video">
              <source src="/assets/Videos/Utilities.mp4" type="video/mp4" />
            </video>

            <div class="container">
              {/* <!-- Content Column --> */}
              <div class="content-column">
                <div class="inner-column">
                  <div
                    class="patern-layer-three"
                    style={{
                      backgroundImage:
                        "url(../../assets/Images/main-slider/pattern-3.png)",
                    }}
                  ></div>
                  <div class="title">
                    <h1>Smart Utility Solutions for the Connected World.</h1>
                  </div>
                  {/* <h1>
                    Empowering businesses with innovative,
                     
                    data-driven IoT solutions.
                  </h1> */}
                  <div class="text">
                    VINCOSYS delivers end-to-end IoT systems for energy, gas,
                    and water — combining advanced hardware with intuitive web
                    and mobile platforms for smarter buildings and communities.{" "}
                  </div>
                  {/* <div class="btns-box">
                    <Link to="" class="theme-btn btn-style-one">
                      <span class="txt">Learn More</span>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div
            class="slide"
            // style={{
            //   // backgroundImage: "url(../../assets/Images/main-slider/iot.png)",
            //   background:"url(../../../../public/assets/Videos/Iot-Video.mp4)",
            // }}
          >
            <video autoPlay loop muted playsInline className="background-video">
              <source src="/assets/Videos/Iot-Video.mp4" type="video/mp4" />
            </video>

            <div class="container">
              {/* <!-- Content Column --> */}
              <div class="content-column">
                <div class="inner-column">
                  <div
                    class="patern-layer-three"
                    style={{
                      backgroundImage:
                        "url(../../assets/Images/main-slider/pattern-3.png)",
                    }}
                  ></div>
                  <div class="title">
                    <h1>Turning Ideas into Connected Experiences.</h1>
                  </div>
                  {/* <h1>
                    Empowering businesses with innovative,
                     
                    data-driven IoT solutions.
                  </h1> */}
                  <div class="text">
                    Transforming concepts into connected products through
                    innovation, precision, and full-stack expertise.
                  </div>
                  {/* <div class="btns-box">
                    <Link to="" class="theme-btn btn-style-one">
                      <span class="txt">Learn More</span>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div
            class="slide"
            // style={{
            //   backgroundImage: "url(../../assets/Images/main-slider/app.png)",
            // }}
          >
            <video autoPlay loop muted playsInline className="background-video">
              <source src="/assets/Videos/mobileapp.mp4" type="video/mp4" />
            </video>
            <div class="container">
              {/* <!-- Content Column --> */}
              <div class="content-column">
                <div class="inner-column">
                  <div
                    class="patern-layer-three"
                    style={{
                      backgroundImage:
                        "url(../../assets/Images/main-slider/pattern-3.png)",
                    }}
                  ></div>
                  <div class="title">
                    <h1>Empower Your Business with Custom Mobile Apps</h1>
                  </div>
                  {/* <h1>
                    Seamless, intuitive mobile app solutions to enhance user
                    engagement and growth.
                  </h1> */}
                  <div class="text">
                    From design to deployment, we build high-performance mobile
                    apps that connect brands with their audiences effectively.
                  </div>
                  {/* <div class="btns-box">
                    <Link to="" class="theme-btn btn-style-one">
                      <span class="txt">Learn More</span>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div
            class="slide"
            // style={{
            //   backgroundImage:
            //     "url(../../assets/Images/main-slider/digital-marketing.png)",
            // }}
          >
            <video autoPlay loop muted playsInline className="background-video">
              <source src="/assets/Videos/dm.mp4" type="video/mp4" />
            </video>
            {/* <div
              class="patern-layer-one"
              style={{
                backgroundImage:
                  "url(../../assets/Images/main-slider/pattern-1.png)",
              }}
            ></div>
            <div
              class="patern-layer-two"
              style={{
                backgroundImage:
                  "url(../../assets/Images/main-slider/pattern-2.png)",
              }}
            ></div> */}
            <div class="container">
              {/* <!-- Content Column --> */}
              <div class="content-column">
                <div class="inner-column">
                  <div
                    class="patern-layer-three"
                    style={{
                      backgroundImage:
                        "url(../../assets/Images/main-slider/pattern-3.png)",
                    }}
                  ></div>
                  <div class="title">
                    <h1>
                      Maximize Your Reach with Strategic Digital Marketing
                      Services
                    </h1>
                  </div>
                  {/* <h1>
                    Boost online presence with   results-driven marketing.
                  </h1> */}
                  <div class="text">
                    Targeted strategies to boost visibility, drive traffic, and
                    engagement.
                  </div>
                  {/* <div class="btns-box">
                    <Link to="" class="theme-btn btn-style-one">
                      <span class="txt">Learn More</span>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
};

export default Secbann;
